<template>
  <v-app :theme="currentTheme">
    <NavBar />
    <!-- Exibe a SideBar apenas se usuário estiver logado e a tela for maior que 670px -->
    <SideBar v-if="user && user.id && !isMobile" />
    <CookieConsentBanner />
    <router-view />
  </v-app>
</template>

<script>
import NavBar from "@/layout/Navbar.vue";
import SideBar from "@/layout/Sidebar.vue";
import { mapState, mapActions } from "vuex";
import CookieConsentBanner from "@/components/common/CookieConsentBanner.vue";

export default {
  name: "App",
  components: { NavBar, SideBar, CookieConsentBanner },
  data() {
    return {
      isMobile: false,
    };
  },
  created() {
    if (!this.user.id) {
      const token = window.localStorage.getItem("token");
      if (token) this.loginUserByToken(token);
    }
    this.handleResize();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.$watch(
      () => this.$route.fullPath,
      () => {
        window.scrollTo(0, 0);
      }
    );
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    ...mapState(["user"]),
    currentTheme() {
      return this.$store.state.theme;
    },
  },
  methods: {
    ...mapActions(["loginUserByToken", "logout"]),
    doLogout() {
      this.logout();
      this.$router.push("/");
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 670;
    },
  },
};
</script>

<style>
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
